import types from "./types";

export const updateLiveData = payload => dispatch =>
  dispatch({
    type: types("live_data").fulfilled,
    payload
  });
